import React from "react";
import tinyColor from "tinycolor2";

import "./ColorPicker.scss";
import { themeColors } from "../../colorMap";

export default function ColorPicker({
  color: selectedColor,
  onChange = () => {},
  defaultColor,
}) {
  if (!selectedColor || !defaultColor) return null;

  const changeColor = React.useCallback((color) => {
    onChange(tinyColor(color).toHexString());
  });

  const colors = React.useMemo(() => {
    const defaultTinyColor = tinyColor(defaultColor);
    return [
      defaultTinyColor,
      ...themeColors.filter(
        (color) => color.toHex() !== defaultTinyColor.toHex(),
      ),
    ].map((c) => c.toHexString());
  }, [defaultColor, themeColors]);

  const circumfrence = Math.PI * 10;
  const arc = circumfrence / colors.length;
  return (
    <div className="color-picker" onClick={(e) => e.stopPropagation()}>
      <label
        className="sample"
        style={{
          backgroundColor: selectedColor,
        }}
      ></label>

      <svg height="20" width="20" viewBox="0 0 20 20">
        {colors
          .map((themeColor, i) => (
            <circle
              key={themeColor}
              r="5"
              cx="10"
              cy="10"
              fill="transparent"
              stroke={themeColor}
              strokeWidth={7}
              strokeDasharray={`0.001 ${i * arc} ${arc} ${circumfrence}`}
              onClick={() => {
                changeColor(themeColor);
              }}
            />
          ))
          .reverse()}
        <circle r="4" cx="10" cy="10" fill={selectedColor || colors[0]} />
      </svg>
    </div>
  );
}
